export type DesignModuleDef = {
  slug: string;
  label: string;
  icon: string;
  title: string;
  description: string;
  navHidden?: boolean;
};

/** Design portal module defs (nav is topbar-only; no bottom dock). */
export const DESIGN_MODULES: DesignModuleDef[] = [
  {
    slug: 'catalogues',
    label: 'Catalogues',
    icon: '🖼',
    title: 'Promo catalogues',
    description: 'Build clearance / promo catalogues from photos and product info.',
  },
];

export const DESIGN_MAIN_MODULES = DESIGN_MODULES.filter((m) => !m.navHidden);
